import { FormattedMessage } from "react-intl";
import { Link, NavLink, useLocation } from "react-router-dom";
import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component";
import { RioNotifications } from "@rio-cloud/rio-notifications-component";
import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader";
import IframeResizer from "iframe-resizer-react";
import { config } from "../../config";
import ServiceInfo from "./ServiceInfo";

interface IAppHeaderProps {
  navItems: { key: string; value: string }[];
}

const AppHeader = ({ navItems }: IAppHeaderProps) => {
  const environment = import.meta.env.PROD ? "production" : "local";
  const location = useLocation();

  const serviceInfoItem = <ServiceInfo />;
  const notifications = <RioNotifications />;
  const userMenuItem = <DefaultUserMenu environment={environment} />;

  const getLabel = () => {
    if (location.pathname.startsWith('/backoffice')) {
      return "UPTIME - BACKOFFICE";
    }
    return <FormattedMessage id="intl-msg:starterTemplate.moduleName" />;
  };

  return (
    <ApplicationHeader
      label={getLabel()}
      appNavigator={
        <IframeResizer
          className="iFrameResizer"
          src={config.backend.MENU_SERVICE}
        />
      }
      navItems={navItems.map((item) => ({
        key: item.key,
        route: <NavLink to={`/${item.key}`}>{item.value}</NavLink>,
      }))}
      homeRoute={<Link to={config.homeRoute || ""} />}
      actionBarItems={[serviceInfoItem, notifications, userMenuItem]}
    />
  );
};

export default AppHeader;
